import { withRouterPath, InjectedProps as WithRouterPathHOC } from 'platform-components/hocs';
import React from 'react';
import { connect } from 'react-redux';

import { getDefaultGrade } from 'utils/get-default-subject-page-grade';

import { ReduxTeacherStore } from '../../../typings';
import ShowcaseView from '../../library.showcase/showcase';
import { getSubjectPages, getCurrentSubjectPage } from '../../library.store/selectors';

import './tab-content__showcase.scss';

interface HOCProps extends WithRouterPathHOC {}
type StoreProps = ReturnType<typeof mapStateToProps>;

interface OwnProps {
    grade: number;
}

interface Props extends HOCProps, StoreProps, OwnProps {}

export class LibraryTabContentShowcase extends React.Component<Props> {
    render() {
        const { currentPage } = this.props;

        return <ShowcaseView description={currentPage?.description} mix="tab-content__showcase" />;
    }
}

const mapStateToProps = (storeState: ReduxTeacherStore, ownProps: HOCProps & OwnProps) => {
    const {
        match: {
            params: { classId, subject },
        },
    } = ownProps;

    const subjectPages = getSubjectPages(storeState, { subject, grade: ownProps.grade });
    const grade = ownProps.grade || getDefaultGrade(subjectPages);

    return {
        // @ts-ignore
        currentPage: getCurrentSubjectPage(storeState, { subject, classId, grade }),
    };
};

export default withRouterPath(connect(mapStateToProps)(LibraryTabContentShowcase));
